import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_TOGGLE_REAL_ESTATE_STATUS } from "../../../config/api";
import { getRealEstateInvestment } from "./getRealEstateInvestment";

export const toggleRealEstateInvestmentStatus = createAsyncThunk(
  "investmentProductStatus/toggle",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await Client({
        method: "PUT",
        path: API_TOGGLE_REAL_ESTATE_STATUS + payload.id,
        data: payload.data,
      });

      dispatch(getRealEstateInvestment(payload?.id));
      if (payload?.cb) {
        payload?.cb();
      }
      toast.success(data?.message);
      return data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      if (payload?.cb) {
        payload?.cb();
      }
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
